module.exports = __webpack_public_path__ + "static/media/under-selected.c9083f4b.png";